<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="18">
        <el-card id="tui-leftCard">
          <div class="tui-cardBox">
            <div class="title">{{ dataInfo.Name }}</div>
            <div class="desc">{{ dataInfo.Description }}</div>
            <div class="flex-items" style="padding: 0.25rem 0">
              <img
                class="img"
                src="http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2023-1/2023-1-9/20230109142344_1640.png"
                alt=""
              />
              <div class="name">{{ dataInfo.Author }}</div>
            </div>
            <div
              class="tui-big"
              :style="{ backgroundImage: 'url(' + dataInfo.Image + ')' }"
            >
              <!-- <div class="tui-positionImg">
                <img
                  src="http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-12/2022-12-30/20221230172122_0097.png"
                  alt=""
                />
              </div> -->
              <div class="tui-positionAdd" @click="onClickAdd">
                <img
                  src="http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-12/2022-12-30/20221230172236_6886.png"
                  alt=""
                />
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card>
          <div class="flex-between" style="padding-bottom: 0.375rem">
            <div class="tui-plan">课程目录</div>
          </div>
          <div class="tui-scroll">
            <div
              class="tui-studyBox"
              v-for="(item, index) in dataInfo.List"
              :key="index"
              @click="onClickVideoDetail(item)"
            >
              <div class="title">{{ item.VideoTitle }}</div>
              <div class="flex-between" style="padding-top: 0.125rem">
                <div class="flex-items">
                  <img
                    src="http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2023-1/2023-1-3/20230103104633_7286.png"
                    alt=""
                  />
                  <div class="time">时长:{{ item.Time }}</div>
                </div>
                <div class="flex-items">
                  <div
                    class="tui-circle"
                    :style="getColor(item.Status, 'bg')"
                  ></div>
                  <div
                    class="tui-status"
                    :style="getColor(item.Status, 'color')"
                  >
                    {{
                      item.Status == 1
                        ? "已完成"
                        : item.Status == 0
                        ? "未学习"
                        : "学习中"
                    }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-dialog title="学习笔记" :visible.sync="dialogVisible" width="30%">
      <div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-position="top"
          class="demo-ruleForm"
        >
          <el-form-item label="课程章节：" prop="VideoId">
            <el-select
              v-model="ruleForm.VideoId"
              placeholder="请选择课程章节"
              style="width: 100%"
            >
              <el-option
                v-for="item in range"
                :key="item.Id"
                :label="item.Name"
                :value="item.Id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="课程笔记：" prop="content">
            <el-input
              type="textarea"
              v-model="ruleForm.content"
              placeholder="请输入课程笔记"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="AddVideoNoteInfo('ruleForm')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  GetVideoDetailList,
  AddVideoNoteInfo,
  GetSelectByVideoList,
} from "../../api/api";

export default {
  data() {
    return {
      dialogVisible: false,
      ruleForm: {
        content: "",
        VideoId: "",
      },
      rules: {
        content: [
          { required: true, message: "请输入课程笔记", trigger: "blur" },
        ],
        VideoId: [
          { required: true, message: "请选择课程章节", trigger: "change" },
        ],
      },
      userInfo: {},
      dataInfo: {},
      PageSize: 1000000,

      range: [],
    };
  },
  async created() {
    this.userInfo = JSON.parse(window.localStorage.user);
    this.GetVideoDetailList();
  },
  watch: {
    dialogVisible(val) {
      // 当弹窗打开时
      // 重置表单，清空校验信息
      this.$nextTick(() => {
        //  延时到下一帧才开始，也就是页面刚刚渲染结束！！
        this.$refs.ruleForm.clearValidate();
      });
    },
  },
  mounted() {},
  methods: {
    onClickVideoDetail(item) {
      this.$router.push({
        path: "/Teacher-Tain/video",
        query: {
          obj: JSON.stringify(item),
        },
      });
    },
    async GetSelectByVideoList() {
      let res = await GetSelectByVideoList({
        Id: this.$route.query.Pid,
      });
      if (res.data.success) {
        this.range = res.data.response;
      }
    },
    async AddVideoNoteInfo(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let res = await AddVideoNoteInfo({
            TeacherId: this.userInfo.TeacherId,
            cateId: this.$route.query.Pid,
            VideoId: this.ruleForm.VideoId,
            content: this.ruleForm.content,
          });
          if (res.data.success) {
            this.$message({
              type: "success",
              message: "成功",
            });
            this.dialogVisible = false;
          } else {
            this.$message({
              type: "error",
              message: res.data.msg,
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    getColor(val, type) {
      if (val == 1) {
        return {
          color: "#31BB0F",
          background: type == "bg" ? "#31BB0F" : "",
        };
      } else if (val == 2) {
        return {
          color: "#F7B500",
          background: type == "bg" ? "#F7B500" : "",
        };
      } else if (val == 0) {
        return {
          color: "#999999",
          background: type == "bg" ? "#999999" : "",
        };
      }
    },
    async GetVideoDetailList() {
      let res = await GetVideoDetailList({
        Pid: this.$route.query.Pid,
        TeacherId: this.userInfo.TeacherId,
        PageIndex: 1,
        PageSize: this.PageSize,
        Name: "",
      });
      if (res.data.success) {
        this.dataInfo = res.data.response;
      }
    },
    onClickAdd() {
      this.dialogVisible = true;
      this.GetSelectByVideoList();
    },
  },
};
</script>
<style lang="less" scoped>
.tui-plan {
  color: #333333;
  font-size: 0.3rem;
  font-weight: 600;
}
.tui-scroll {
  height: 10.5rem;
  overflow-y: scroll;
  .tui-studyBox {
    width: 100%;
    background: #f9f9f9;
    border-radius: 0.125rem;
    margin: 0 auto;
    padding: 0.25rem;
    box-sizing: border-box;
    margin-bottom: 0.25rem;
    cursor: pointer;
    .tui-circle {
      width: 0.1rem;
      height: 0.1rem;
      background: #ff4d60;
      border-radius: 50%;
    }
    .tui-status {
      color: #31bb0f;
      font-size: 0.2rem;
      padding-left: 0.0625rem;
    }
    .time {
      color: #999;
      font-size: 0.2rem;
      padding-left: 0.125rem;
    }
    img {
      width: 0.225rem;
      height: 0.225rem;
    }
    .title {
      color: #333333;
      font-size: 0.25rem;
    }
  }
}
.tui-Num {
  color: #2fb9ff;
  font-size: 0.25rem;
  font-weight: 600;
  span {
    color: #333;
  }
}
.tui-percent {
  color: #999999;
  font-size: 0.225rem;
}
.tui-cardBox {
  padding: 0.3rem;
  box-sizing: border-box;
  .tui-big {
    width: 100%;
    height: 8.7625rem;
    border-radius: 0.25rem;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    position: relative;
    .tui-positionAdd {
      width: 0.6625rem;
      height: 0.6625rem;
      position: absolute;
      right: 0.3375rem;
      bottom: 0.35rem;
      cursor: pointer;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .tui-positionImg {
      width: 1rem;
      height: 1rem;
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      margin: auto;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .title {
    color: #333333;
    font-size: 0.3rem;
    font-weight: 600;
  }
  .name {
    color: #666666;
    font-size: 0.25rem;
    padding-left: 0.125rem;
  }
  .img {
    width: 0.5rem;
    height: 0.5rem;
    box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.05);
  }
  .desc {
    color: #999999;
    font-size: 0.225rem;
    padding-top: 0.125rem;
  }
}
</style>